/* Delegation also covers cards loaded by predictive search and recommendations. */
(() => {
  const active = new WeakMap();
  function preview(dot) {
    const card = dot.closest('product-card, .u-product-card, .product-card, .hl-product-card');
    const img = card?.querySelector('.card-gallery img, .u-product-card__image img, img');
    if (!img || !dot.dataset.hlColorPreview) return;
    if (!active.has(card)) active.set(card, { img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset') });
    img.removeAttribute('srcset');
    img.src = dot.dataset.hlColorPreview;
    card.classList.add('hl-color-preview-active');
  }
  function restore(dot) {
    const card = dot.closest('product-card, .u-product-card, .product-card, .hl-product-card');
    const state = card && active.get(card);
    if (!state) return;
    if (state.srcset) state.img.setAttribute('srcset', state.srcset);
    if (state.src) state.img.src = state.src;
    active.delete(card);
    card.classList.remove('hl-color-preview-active');
  }
  document.addEventListener('pointerover', e => { const dot = e.target.closest('[data-hl-color-preview]'); if (dot) preview(dot); });
  document.addEventListener('pointerover', e => {
    const media = e.target.closest('.card-gallery, .u-product-card__media, .u-product-card__image, .hl-product-card__media');
    if (media) restore(media);
  });
  document.addEventListener('pointerout', e => {
    const card = e.target.closest('product-card, .u-product-card, .product-card, .hl-product-card');
    if (card && !card.contains(e.relatedTarget)) restore(card);
  });
  document.addEventListener('focusin', e => { const dot = e.target.closest('[data-hl-color-preview]'); if (dot) preview(dot); });
  document.addEventListener('focusout', e => { const dot = e.target.closest('[data-hl-color-preview]'); if (dot) restore(dot); });
  document.addEventListener('click', e => { const dot = e.target.closest('[data-hl-color-preview]'); if (dot) { e.preventDefault(); e.stopPropagation(); preview(dot); } }, true);
  function groupSizes() {
    const source = document.querySelector('[data-hl-size-groups]');
    if (!source) return;
    let kids; try { kids = JSON.parse(source.textContent); } catch { return; }
    if (!Array.isArray(kids) || !kids.length) return;
    document.querySelectorAll('variant-picker fieldset, [data-u-option-group]').forEach(field => {
      if (field.dataset.hlGrouped || field.hasAttribute('data-hl-color-option') || field.classList.contains('u-option--color')) return;
      const labels = [...field.querySelectorAll('label')].filter(label => label.querySelector('input[type=radio]'));
      if (!labels.some(label => kids.includes(label.querySelector('input').value))) return;
      field.dataset.hlGrouped = 'true';
      const italian = document.documentElement.lang.startsWith('it');
      for (const child of [false, true]) {
        const matches = labels.filter(label => kids.includes(label.querySelector('input').value) === child);
        if (!matches.length) continue;
        const group = document.createElement('div'); group.className = 'hl-size-group';
        const heading = document.createElement('p'); heading.className = 'hl-size-group__title';
        heading.textContent = child ? (italian ? 'Bambino' : 'Kids') : (italian ? 'Adulto' : 'Adult');
        group.append(heading, ...matches); field.append(group);
      }
    });
  }
  function installModes() {
    const index = document.querySelector('[data-hl-gallery-index]');
    const field = document.querySelector('variant-picker [data-hl-color-option], .u-option--color');
    if (!index || !field || field.querySelector('.hl-gallery-modes')) return;
    let photos; try { photos = JSON.parse(index.textContent); } catch { return; }
    const worn = photo => /\[worn\]|—\s*(adult|child|woman|man|model)\b|\/model\//i.test(photo.alt || '') || /\/model\//i.test(photo.src);
    if (!photos.some(worn)) return;
    const italian = document.documentElement.lang.startsWith('it');
    const controls = document.createElement('div'); controls.className = 'hl-gallery-modes'; controls.setAttribute('aria-label', italian ? 'Visualizzazione fotografie' : 'Photo view');
    for (const mode of ['model', 'product']) {
      const button = document.createElement('button'); button.type = 'button'; button.textContent = mode === 'model' ? (italian ? 'Indossato' : 'On model') : (italian ? 'Prodotto' : 'Product'); button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => {
        const gallery = document.querySelector('.product-information media-gallery, .u-product__gallery');
        if (!gallery) return;
        const color = field.querySelector('input:checked')?.value?.toLowerCase() || '';
        let matching = photos.filter(photo => mode === 'model' ? worn(photo) : !worn(photo) && (!color || photo.colors.some(c => c.toLowerCase() === color) || (photo.alt || '').toLowerCase().includes(`[color: ${color}]`)));
        if (mode === 'product' && !color) matching = matching.slice(0, 4);
        if (!matching.length) return;
        gallery.querySelector('.hl-gallery-mode-images')?.remove();
        const list = document.createElement('div'); list.className = 'hl-gallery-mode-images';
        matching.forEach((photo, i) => { const frame = document.createElement('div'); const img = document.createElement('img'); img.src = photo.src; img.alt = photo.alt || ''; img.loading = i ? 'lazy' : 'eager'; img.width = 1000; img.height = 1000; frame.append(img); list.append(frame); });
        gallery.classList.add('hl-gallery-override'); gallery.append(list);
        controls.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      });
      controls.append(button);
    }
    field.append(controls);
  }
  document.addEventListener('change', e => { if (e.target.matches('variant-picker input[type=radio], [data-u-option]')) { document.querySelectorAll('.hl-gallery-override').forEach(g => { g.classList.remove('hl-gallery-override'); g.querySelector('.hl-gallery-mode-images')?.remove(); }); document.querySelectorAll('.hl-gallery-modes button').forEach(b => b.setAttribute('aria-pressed', 'false')); } });
  let scheduled;
  if (document.querySelector('.hl-official-size-guide')) document.querySelectorAll('summary').forEach(s => { if (!s.closest('.hl-official-size-guide') && /^(size guide|guida (alle )?taglie)$/i.test(s.textContent.trim())) s.parentElement.hidden = true; });
  new MutationObserver(() => { if (!scheduled) scheduled = requestAnimationFrame(() => { scheduled = null; groupSizes(); installModes(); }); }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  groupSizes();
  installModes();
})();
